import React from "react";
import { Phone, Mail, MapPin, ArrowUp } from "lucide-react";
import { Link } from "react-router-dom";
import { Logo } from "./Logo";
import { footerData, contactInfo, navigation } from "../data/mock";

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <footer className="bg-primary text-white">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Company Info */}
          <div className="lg:col-span-1">
            <div className="flex items-center gap-3 mb-6">
              <Logo size="default" />
              <div className="flex flex-col">
                <span className="font-bold text-lg text-white">Gerüst Sanierung</span>
                <span className="text-xs text-white/70">Robert Recher</span>
              </div>
            </div>
            <p className="text-white/70 text-sm leading-relaxed mb-6">
              Reparatur & Aufbereitung von Gerüstböden – wirtschaftlich, fachgerecht, transparent. Für Gerüstbauer und Baufirmen in Deutschland und Italien.
            </p>
            <div className="space-y-3">
              <a
                href={`tel:${contactInfo.phoneShort.replace(/\s/g, "")}`}
                className="flex items-center gap-3 text-white/80 hover:text-accent transition-colors text-sm"
              >
                <Phone className="w-4 h-4" />
                {contactInfo.phone}
              </a>
              <a
                href={`tel:${contactInfo.mobileShort.replace(/\s/g, "")}`}
                className="flex items-center gap-3 text-white/80 hover:text-accent transition-colors text-sm"
              >
                <Phone className="w-4 h-4" />
                {contactInfo.mobile}
              </a>
              <a
                href={`mailto:${contactInfo.email}`}
                className="flex items-center gap-3 text-white/80 hover:text-accent transition-colors text-sm"
              >
                <Mail className="w-4 h-4" />
                {contactInfo.email}
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold text-lg mb-6">Navigation</h4>
            <ul className="space-y-3">
              {navigation.map((item) => (
                <li key={item.href}>
                  <a
                    href={item.href}
                    className="text-white/70 hover:text-accent transition-colors text-sm"
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Impressum */}
          <div>
            <h4 className="font-semibold text-lg mb-6">{footerData.impressum.title}</h4>
            <ul className="space-y-2">
              {footerData.impressum.lines.map((line, index) => (
                <li key={index} className="text-white/70 text-sm">
                  {line}
                </li>
              ))}
            </ul>
          </div>

          {/* Rechtliches */}
          <div>
            <h4 className="font-semibold text-lg mb-6">{footerData.legal.title}</h4>
            <ul className="space-y-2">
              {footerData.legal.lines.map((line, index) => (
                <li key={index} className="text-white/70 text-sm">
                  {line}
                </li>
              ))}
            </ul>
            <div className="mt-6 pt-6 border-t border-white/10">
              <div className="flex items-start gap-2 text-white/60 text-xs">
                <MapPin className="w-4 h-4 mt-0.5 flex-shrink-0" />
                <div>
                  <p>{contactInfo.postAddress.street}</p>
                  <p>{contactInfo.postAddress.city}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-white/60 text-sm">
              © {currentYear} Gerüst Sanierung – Robert Recher. Alle Rechte vorbehalten.
            </p>
            <div className="flex items-center gap-6">
              <Link
                to="/impressum"
                className="text-white/60 hover:text-accent transition-colors text-sm"
              >
                Impressum
              </Link>
              <Link
                to="/datenschutz"
                className="text-white/60 hover:text-accent transition-colors text-sm"
              >
                Datenschutz
              </Link>
              <button
                onClick={scrollToTop}
                className="flex items-center gap-2 text-white/60 hover:text-accent transition-colors text-sm group"
              >
                Nach oben
                <ArrowUp className="w-4 h-4 group-hover:-translate-y-1 transition-transform" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
